import { Component, HostBinding, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ConditionalTemplateRunner } from '../../service/data';

@Component({
	selector: 'common-ct-runner-input',
	templateUrl: './ct-runner-input.component.html',
	styleUrls: ['./ct-runner-input.component.scss']
})
export class CtRunnerInputComponent implements OnInit {
	@HostBinding('class.ct-runner-input') hostClass = true;
	@Input() data: ConditionalTemplateRunner;
	@Output() enterPress = new EventEmitter();
	constructor() {}

	ngOnInit() {}
}
